export const useRedirect = () => {
  const route = useRoute();
  const { path, query, hash } = route;
  const getNextRoute = (nextPath: string) => {
    return { path: nextPath, query, hash };
  };
  const redirect = async (url: string) => {
    await navigateTo(getNextRoute(url), {
      redirectCode: 301,
    });
  };
  return {
    getNextRoute,
    redirect,
  };
};
